import axios from 'axios'
import { Message } from 'element-ui'
import Router from '@/router/index'
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.headers['Content-Type'] = ' application/json'
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  if(typeof response.data.retCode !== 'undefined') {
    if (response.data.retCode !== 1) {
      if (response.data.retCode === 1000) {
        // Message.error(response.data.retMsg)
        Router.replace('/homeIndex')
      } else {
        // Message.error(response.data.retMsg)
      }
      
    }
  }
  // 对响应数据做点什么
  return response
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/assets/js/axiosConfig.js